import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { Modal } from 'antd'
import moment from 'moment';
import axios from 'axios';

import Swal from 'sweetalert2';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';
import Pagination from '@mui/material/Pagination';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';

import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import Search from '@mui/icons-material/Search';

import brand from 'contexts/brand';

import { doDownloadStudy, handleDownloadIamges } from 'helpers/handleDownloadIamges';
import handleDownloadStudy from 'helpers/handleDownloadStudy';
import handleOpenReport from 'helpers/handleOpenReport';
import handleOpenViewer from 'helpers/handleOpenViewer';
import handlePrintStudy from 'helpers/handlePrintStudy';

import ReportModal from 'components/ReportModal';
import ViewerModal from 'components/ViewerModal';

import { classes } from './styles/DashboardStyle';
import { tableStyle } from './styles/TableSyle';

import logo from 'images/human_logo.png';
import humanDr from 'images/human_dr.png';
import vetDr from 'images/vet_dr.png';
import humanLogoHeader from 'images/human_logo_header.png';
import vetLogoHeader from 'images/vet_logo_header.png';
import backgroundHuman from 'images/background_human.png';
import backgroundVet from 'images/background_vet.png';
import { useTranslation } from 'react-i18next';
import LanguageSelector from './LanguageSelector';


const CHECK_DOWNLOAD_INTERVAL = 3000;

const DashboardDoctors = () => {
  const isSmall = useMediaQuery('(max-width: 800px)');
  const isMedium = useMediaQuery('(max-width: 1100px)');

  const navigate = useNavigate();

  const [account, setAccount] = useState({});
  const [loading, setLoading] = useState(false);
  const [studies, setStudies] = useState([]);
  const [user, setUser] = useState({});
  const { i18n, t } = useTranslation();
  const formatDate = i18n.language === 'en' || i18n.language === 'en-US' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';

  // pesquisa
  const [draftFilters, setDraftFilters] = useState({ patientName: null, dicomCreatedEnd: null, dicomCreatedStart: null });
  const [filters, setFilters] = useState({ patientName: null, dicomCreatedEnd: null, dicomCreatedStart: null });

  const handleDraftChange = (field) => (e) => {
    setDraftFilters((prev) => ({
      ...prev,
      [field]: e.target.value.length > 0 ? e.target.value : null
    }));
  };

  const handleFilterBlur = (field) => () => {
    if(filters[field] !== draftFilters[field]) {
      setFilters((prev) => ({
        ...prev,
        [field]: draftFilters[field]
      }));
    }
  };

  // paginação
  const [countStudy, setCountStudy] = useState(0); // contador de estudos mostrados até a pagina atual
  const [page, setPage] = useState(1); // pagina atual
  const pageSize = 15; // limite de estudos por pagina
  const [paginationCount, setPaginationCount] = useState(0); // quantidade de paginas
  const [totalStudies, setTotalStudies] = useState(); // total de estudos

  const logout = () => {
    localStorage.removeItem('authSession');
    navigate('/doctors');
  };

  useEffect(() => {
    setLoading(true);

    const authSession = localStorage.getItem('authSession');
    const { accessToken } = JSON.parse(authSession);

    if (accessToken) {
      axios.get('/external/listResultsDoctors', {
        headers: {
          access_token: accessToken
        },
        params: {
          ...filters,
          limit: pageSize,
          offset: pageSize * (page - 1)
        }
      }
      ).then((res) => {
        const { data } = res;

        setAccount(data?.account);
        setStudies(data?.studies?.studyList);
        setUser(data?.user);

        // paginação
        setCountStudy(
          data?.studies?.pagination?.totalItems < (pageSize * page)
            ? data?.studies?.pagination?.totalItems
            : (pageSize * page)
        );
        setPaginationCount(
          data?.studies?.pagination?.totalItems > 0
            ? Math.ceil(data?.studies?.pagination?.totalItems / data?.studies?.pagination?.limit)
            : 0
        );
        setTotalStudies(data?.studies?.pagination?.totalItems);

        localStorage.setItem('authSession', JSON.stringify(data?.user));

        setLoading(false);
      }).catch((error) => {
        const text = error?.response?.data?.error?.description || 'Tente novamente mais tarde';

        Swal.fire({
          type: 'error',
          title: 'Ocorreu um erro!',
          text: text,
          heightAuto: false
        });

        logout();
      });
    } else {
      // Sem token, redireciona
      logout();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, page]);

  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };

  // abertura de laudo
  const [downloadLaudoUrl, setDownloadLaudoUrl] = useState();
  const [laudoOpen, setLaudoOpen] = useState(false);
  const [loadingLaudo, setLoadingLaudo] = useState(false);
  const [urlLaudo, setUrlLaudo] = useState();

  // abertura de imagens
  const [viewerUrl, setViewerUrl] = useState(false);

  // imprimir imagens
  const printCanceled = useRef(false);
  const printTotalTime = useRef();
  const [printBuffer, setPrintBuffer] = useState();
  const [printStatus, setPrintStatus] = useState('none');

  useEffect(() => {
    if (printCanceled.current === false && printBuffer) {
      // Abrindo o PDF
      try {
        const file = new Blob([printBuffer], { type: 'application/pdf' });
        const printWindow = window.open(window.URL.createObjectURL(file), '_blank');
        if (!printWindow) {
          throw new Error(t('Verifique o bloqueador de pop-ups do seu navegador'));
        }
      } catch (e) {
        window.alert(e.message);
      }
    };

    setPrintBuffer(null);
    setPrintStatus('none');
  }, [printBuffer, t]);

  // baixar imagens e DICOMs
  const downloadZipUrl = useRef();
  const canDownload = account?.canDownload || false;
  const [downloadStatus, setDownloadStatus] = useState('none');


  if (loading) {
    return (
      <Container
        maxWidth='sm'
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%'
        }}
      >
        <CircularProgress sx={{ mb: 3 }} />
      </Container>
    )
  };

  return (
    <>
      <AppBar color='primary' position='static' sx={classes.appBar}>
        <img
          src={brand === 'vet' ? vetLogoHeader : humanLogoHeader}
          alt={brand === 'vet' ? 'Dr. Nuvem' : 'Dr. Tis'}
          style={{ maxHeight: 30 }}
        />

        <Box sx={{ display: 'flex', alignItems: 'center', marginLeft: 'auto'}}>
            <LanguageSelector />
            <Button
            endIcon={<ExitToAppIcon />}
            onClick={logout}
            variant='contained'
            color='primary'
            sx={{ ml: 2 }}
          >
            {t('Sair')}
          </Button>
        </Box>
        
      </AppBar>

      <div
        style={{
          height: '100vh',
          backgroundImage: !isSmall && (brand === 'vet' ? `url(${backgroundVet}`: `url(${backgroundHuman})`),
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          overflow: 'auto'
        }}
      >
        <Container
          sx={{
            overflow: 'auto',
            padding: studies?.length > 0
              ? { xs: '3vh 3vw 3vh', sm: '4.5vh 3vw 9.7vh' }
              : { xs: '5vh 3vw 3vh', sm: '15vh 3vw 9.7vh' }
          }}
        >
          <Paper sx={{
            ...classes.paper,
            padding: studies?.length > 0 ? '20px' : '30px'
          }}>
            <Grid sx={classes.infoUser}>
              {account?.accountLogo ? (
                <Box
                  component='img'
                  src={account.accountLogo}
                  alt={account?.accountName}
                  sx={classes.logo}
                />
              ) : (
                <Box
                  component='img'
                  src={brand === 'vet' ? vetDr : humanDr}
                  alt={brand === 'vet' ? 'Dr. Nuvem' : 'Dr. Tis'}
                  sx={classes.logo}
                />
              )}

              <Grid item>
                <Typography variant='h3'>
                  {t('Portal de resultados')} {account.accountName}
                </Typography>
                <Typography variant='h4' style={{ margin: '.5rem 0 0' }}>
                  {t('Bem vindo(a)')} {user.name}
                </Typography>
              </Grid>
            </Grid>
          </Paper>

          <Paper sx={tableStyle.paperContainerTable}>
            <Box sx={tableStyle.containerFilters}>
              <FormControl>
                <Typography sx={tableStyle.inputLabelFilters}> {t('Paciente')} </Typography>
                <OutlinedInput
                  fullWidth
                  sx={tableStyle.textField}
                  placeholder={t('Nome do paciente')}
                  value={draftFilters.patientName}
                  onChange={handleDraftChange('patientName')}
                  onBlur={handleFilterBlur('patientName')}
                  endAdornment={
                    <InputAdornment position='end'>
                      <Search />
                    </InputAdornment>
                  }
                />
              </FormControl>
              <FormControl>
                <Typography sx={tableStyle.inputLabelFilters}> {t('Data inicial')} </Typography>
                <OutlinedInput
                  fullWidth
                  sx={{ ...tableStyle.textField, ...tableStyle.dateField }}
                  type='date'
                  placeholder={t('Data inicial')}
                  value={draftFilters.dicomCreatedStart}
                  onChange={handleDraftChange('dicomCreatedStart')}
                  onBlur={handleFilterBlur('dicomCreatedStart')}
                  inputProps={{
                    max: new Date().toISOString().split('T')[0]
                  }}
                  endAdornment={
                    <InputAdornment position='end'>
                      <CalendarTodayOutlinedIcon />
                    </InputAdornment>
                  }
                />
              </FormControl>
              <FormControl>
                <Typography sx={tableStyle.inputLabelFilters}> {t('Data final')} </Typography>
                <OutlinedInput
                  fullWidth
                  sx={{ ...tableStyle.textField, ...tableStyle.dateField }}
                  type='date'
                  placeholder={t('Data final')}
                  value={draftFilters.dicomCreatedEnd}
                  onChange={handleDraftChange('dicomCreatedEnd')}
                  onBlur={handleFilterBlur('dicomCreatedEnd')}
                  inputProps={{
                    min: draftFilters.dicomCreatedStart
                  }}
                  endAdornment={
                    <InputAdornment position='end'>
                      <CalendarTodayOutlinedIcon />
                    </InputAdornment>
                  }
                />
              </FormControl>
            </Box>
            {studies?.length > 0 ? (
              <TableContainer sx={tableStyle.containerTable}>
                <Table sx={tableStyle.table}>
                  <TableHead sx={tableStyle.tableHead}>
                    <TableRow>
                      <TableCell>{t('DATA DO EXAME')}</TableCell>
                      <TableCell>{t('PACIENTE')}</TableCell>
                      <TableCell>{t('PROCEDIMENTO')}</TableCell>
                      <TableCell>{t('Modalidade')}</TableCell>
                      <TableCell>{t('Status do laudo')}</TableCell>
                      <TableCell>{t('Instituição')}</TableCell>
                      <TableCell>{t('Ver imagens')}</TableCell>
                      <TableCell>{t('Imprimir imagens')}</TableCell>
                      {canDownload && <TableCell>{t('Baixar imagens')}</TableCell>}
                      {canDownload && <TableCell>{t('Baixar DICOM')}</TableCell>}
                    </TableRow>
                  </TableHead>
                  <TableBody sx={tableStyle.tableBody}>
                    {studies.map((data, idx) => (
                      <TableRow key={idx}>
                        <TableCell sx={tableStyle.tableCell}>
                          {moment(data.dicomCreatedAt).format(formatDate)}
                        </TableCell>
                        <TableCell sx={tableStyle.tableCell}>
                          {data.isForHuman === false ? data.patientName : (data.socialName || data.patientName)}
                        </TableCell>
                        <TableCell sx={tableStyle.tableCell}>{data.examType}</TableCell>
                        <TableCell sx={tableStyle.tableCell}>
                          {data.modalities[0]}
                        </TableCell>
                        <TableCell sx={{ ...tableStyle.tableCell, ...tableStyle.tableCellAction }}>
                          <Tooltip title='Abrir laudo'>
                            <IconButton
                              onClick={() => handleOpenReport(
                                user.accountId, data.downloadReportUrl, data?.patientName,
                                setDownloadLaudoUrl, setLaudoOpen, setLoadingLaudo, setUrlLaudo, data?.id, user
                              )}
                              disabled={!data?.downloadReportUrl}
                            >
                              {loadingLaudo ? (
                                <CircularProgress size={20} color='secondary' />
                              ) : (
                                data?.downloadReportUrl
                                  ? <CheckCircleOutlineIcon color='secondary' />
                                  : <HighlightOffIcon color='primary' style={{ opacity: '.4' }}/>
                              )}
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                        <TableCell sx={tableStyle.tableCell}>
                          {data.institutionName}
                        </TableCell>
                        <TableCell sx={tableStyle.tableCell}>
                          {(data.storageClass === 'GLACIER' || data.storageClass === 'DEEP_ARCHIVE') ? (
                            <Tooltip title={t('Imagens não disponíveis')}>
                              <ReportProblemOutlinedIcon color='primary' fontSize='large' />
                            </Tooltip>
                          ) : (
                            <Button
                              sx={tableStyle.tableCellButton}
                              onClick={() => handleOpenViewer(
                                user.accountId, data?.patientName, setViewerUrl, data?.id, user, data.viewerLink
                              )}
                              disabled={data.storageClass === 'GLACIER' || data.storageClass === 'DEEP_ARCHIVE'}
                            >
                              {t('Ver imagens')}
                            </Button>
                          )}
                        </TableCell>
                        <TableCell sx={tableStyle.tableCell}>
                          {(!data?.printImagesLink || data.storageClass === 'GLACIER'
                            || data.storageClass === 'DEEP_ARCHIVE') ? (
                            <Tooltip title={t('Imagens não disponíveis')}>
                              <ReportProblemOutlinedIcon color='primary' fontSize='large' />
                            </Tooltip>
                          ) : (
                            <Button
                              sx={tableStyle.tableCellButton}
                              onClick={() => handlePrintStudy(
                                user.accountId, data?.patientName, printCanceled, data.printStudyLink,
                                printTotalTime, setPrintBuffer, setPrintStatus, data?.id, user
                              )}
                              disabled={!data?.printImagesLink
                                || (data.storageClass === 'GLACIER' || data.storageClass === 'DEEP_ARCHIVE')}
                            >
                              {t('Imprimir imagens')}
                            </Button>
                          )}
                        </TableCell>
                        {canDownload && (
                          <TableCell sx={tableStyle.tableCell}>
                            {(!data?.printImagesLink || data.storageClass === 'GLACIER'
                              || data.storageClass === 'DEEP_ARCHIVE') ? (
                              <Tooltip title={t('Imagens não disponíveis')}>
                                <ReportProblemOutlinedIcon color='primary' fontSize='large' />
                              </Tooltip>
                            ) : (
                              <Button
                                sx={tableStyle.tableCellButton}
                                onClick={() => handleDownloadIamges(
                                  user.accountId, data?.checkDownloadLink, CHECK_DOWNLOAD_INTERVAL, data?.downloadImagesLink,
                                  downloadZipUrl, data?.patientName, setDownloadStatus, data?.id, user
                                )}
                                disabled={!data?.downloadImagesLink
                                  || (data.storageClass === 'GLACIER' || data.storageClass === 'DEEP_ARCHIVE')}
                              >
                                Baixar imagens
                              </Button>
                            )}
                          </TableCell>
                        )}
                        {canDownload && (
                          <TableCell sx={tableStyle.tableCell}>
                            {(!data?.printImagesLink || data.storageClass === 'GLACIER'
                              || data.storageClass === 'DEEP_ARCHIVE') ? (
                              <Tooltip title={t('Imagens não disponíveis')}>
                                <ReportProblemOutlinedIcon color='primary' fontSize='large' />
                              </Tooltip>
                            ) : (
                              <Button
                                sx={tableStyle.tableCellButton}
                                onClick={() => handleDownloadStudy(
                                  user.accountId, data?.checkDownloadLink, CHECK_DOWNLOAD_INTERVAL, data?.downloadStudyLink,
                                  downloadZipUrl, data?.patientName, setDownloadStatus, data?.id, user
                                )}
                                disabled={!data?.downloadStudyLink
                                  || (data.storageClass === 'GLACIER' || data.storageClass === 'DEEP_ARCHIVE')}
                              >
                                {t('Baixar DICOM')}
                              </Button>
                            )}
                          </TableCell>
                        )}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Typography variant='h3' sx={{ margin: '2.5rem auto .5rem', textAlign: 'center' }}>
                {t('Nenhum exame foi encontrado')}
              </Typography>
            )}
            {paginationCount > 0 && (
              <Box sx={tableStyle.containerPagination}>
                <Typography>
                  {`${t('Mostrando')} ${(pageSize * (page - 1) + 1)} ${t('até')} ${countStudy} ${t('de')} ${totalStudies} ${t('resultados')}`}
                </Typography>
                <Stack>
                  <Pagination
                    page={page}
                    count={paginationCount} // número total de paginas
                    variant='outlined'
                    shape='rounded'
                    onChange={handleChangePage}
                    siblingCount={isSmall ? 0 : isMedium ? 2 : 3}
                  />
                </Stack>
              </Box>
            )}
          </Paper>

          <Modal
            maskClosable={false}
            title={t('Baixar estudo')}
            visible={downloadStatus !== 'none'}
            okButtonProps={{
              disabled: downloadStatus !== 'done',
              loading: downloadStatus === 'zipping'
            }}
            onOk={() => doDownloadStudy(downloadZipUrl)}
            okText={t('Baixar')}
            onCancel={() => setDownloadStatus('none')}
          >
            {downloadStatus === 'zipping' && t('Gerando o zip das imagens')}
            {downloadStatus === 'done' &&
              t('Pronto! Clique em "Baixar" para fazer o download')}
            {downloadStatus.startsWith('Erro') && downloadStatus}
          </Modal>

          <Modal
            maskClosable={false}
            title={t('Imprimir estudo')}
            visible={printStatus !== 'none'}
            okButtonProps={{
              disabled: printStatus !== 'done',
              loading: printStatus === 'printing'
            }}
            onCancel={() => {
              setPrintStatus('none');
              printCanceled.current = true;
            }}
          >
            {printStatus === 'printing' && t('Imprimindo o estudo')}
            {printStatus.startsWith('Erro') && printStatus}
          </Modal>

          {brand === 'human' && isSmall &&
            <Box sx={{ textAlign: 'center', marginTop: '7.2vw' }}>
              <a href='https://drtis.com.br'>
                <img src={logo} alt={'Dr. Tis'} height='42' />
              </a>
            </Box>
          }
        </Container>
      </div>
      { !isMobile && <ReportModal open={laudoOpen} url={urlLaudo} downloadUrl={downloadLaudoUrl} onClose={() => setLaudoOpen(false)} /> }
      <ViewerModal open={!!viewerUrl} viewerUrl={viewerUrl} onClose={() => setViewerUrl(undefined)} />
    </>
  );
};

export default DashboardDoctors;